// removed by extract-text-webpack-plugin
module.exports = {"avatarImgOption":"PeoplePicker__avatarImgOption___gpshq","avatarImgSelect":"PeoplePicker__avatarImgSelect___Q_DLU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PeoplePicker/PeoplePicker.scss
// module id = 517
// module chunks = 1